// Trulux Franchise — Popup open/close
(function() {
  function initFranForm() {
    var overlay = document.getElementById('franFormOverlay');
    var closeBtn = document.getElementById('franFormClose');
    var openBtns = document.querySelectorAll('.open-fran-form');

    if (!overlay) return;

    function openOverlay() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeOverlay() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function(btn) {
      btn.addEventListener('click', openOverlay);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeOverlay);
    }

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeOverlay();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFranForm);
  } else {
    initFranForm();
  }

  document.addEventListener('shopify:section:load', initFranForm);
})();
